export const isSSR = typeof window === 'undefined';
export const isProd = process.env.NODE_ENV === 'production';
export const isDev = !isProd;
export const isVercelProd = process.env.NEXT_PUBLIC_VERCEL_ENV === 'production';
